import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/about/page.tsx");
